import { render, staticRenderFns } from "./EmployeeSalarySettingInfo.vue?vue&type=template&id=2f5fc7b1&scoped=true&"
import script from "./EmployeeSalarySettingInfo.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5fc7b1",
  null
  
)

export default component.exports